import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19 2.25c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 7.75h-3A1.75 1.75 0 0 1 14.25 6v-.25H11a.25.25 0 0 0-.25.25v5.25h3.5V11c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 14.75h-3A1.75 1.75 0 0 1 14.25 13v-.25h-3.5V18c0 .138.112.25.25.25h3.25V18c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 21.75h-3A1.75 1.75 0 0 1 14.25 20v-.25H11A1.75 1.75 0 0 1 9.25 18v-5.25h-1.5V15A1.75 1.75 0 0 1 6 16.75H4A1.75 1.75 0 0 1 2.25 15V9c0-.966.784-1.75 1.75-1.75h2c.966 0 1.75.784 1.75 1.75v2.25h1.5V6c0-.966.784-1.75 1.75-1.75h3.25V4c0-.966.784-1.75 1.75-1.75zm-3 15.5a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zm-12-9a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25V9A.25.25 0 0 0 6 8.75zm12 2a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zm0-7a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }